import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DataStorageService } from '../data-storage.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-success-info',
  templateUrl: './success-info.component.html',
  styleUrls: ['./success-info.component.css']
})
export class SuccessInfoComponent implements OnInit {

  constructor(private router: Router,
    private dataStorageService: DataStorageService,
    private translate: TranslateService) { }

  subscription: Subscription;
  lang: string;

  ngOnInit() {
    this.subscription = this.dataStorageService.langData$.subscribe((data) => {
      this.lang = data;
      if (this.lang == '' || this.lang == null) {
        this.lang = localStorage.getItem("lang");
      }
      this.translate.use(this.lang);
    })
    this.router.navigate(['user/change-mobile']);
  }

  closeUp() {

  }

}



// WEBPACK FOOTER //
// ./src/app/shared/success-info/success-info.component.ts